<template>
  <div>
    <input
      v-if="type === 'text'"
      v-model="value"
      class="input11 input-text-border-none"
      :class="align"
      min="0"
      :maxlength="max"
      :type="type"
      @focus="onFocus"
      @blur="changeInput"
    />
    <div v-if="type === 'number'">
      <VxCurrencyInput
        v-model="value"
        class="input-text-border-none align-right"
        @focus="onFocus"
        @blur="changeInput"
      />
    </div>

    <!-- <span v-else>{{ value }}</span> -->
  </div>
</template>

<script>
/* eslint-disable */
import { defineComponent } from 'vue'
import VxCurrencyInput from '@/components/ui/VxCurrencyInput.vue'

export default defineComponent({
  // props: {
  //   params: {
  //     type: Object,
  //     default: null
  //   }
  // },
  components: {
    VxCurrencyInput
  },
  data() {
    return {
      value: '',
      type: 'text',
      colName: null,
      align: 'align-right',
      disabled: false,
      max: null
    }
  },
  methods: {
    changeInput() {
      if (this.type === 'number') {
        this.params.context.componentParent.textInputChange(
          this.params,
          +this.value,
          this.colName
        )
      } else {
        this.params.context.componentParent.textInputChange(
          this.params,
          this.value,
          this.colName
        )
      }
    },
    onFocus() {
      const elInputs = document.querySelectorAll('.input11')
    }
  },
  beforeMount() {
    console.log('check poaram text input', this.params)
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    if (this.params?.align !== null && this.params?.align !== undefined) {
      this.align = this.params.align
    }
    if (this.params?.max !== null && this.params?.max !== undefined) {
      this.max = this.params.max
    }
    // console.log('HAHAHAAAAAA:', this.params)
    this.params.disabled ? (this.disabled = this.params.disabled) : false
    this.params.type ? (this.type = this.params.type) : null
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  }
})
</script>
